import { useTranslation } from "react-i18next";
import { PaymentBreakdownSectionProps } from "../types";
import { /*formatAmount ,*/ formatMonetaryAmount } from "@/utils/numbers.utils";
import { InfoSection, InfoRow } from "@/components/ui/data-display";
import { CurrencyAmount } from "@/components/ui/CurrencyAmount";

export function PaymentBreakdownSection({
  mezzaCreditsAmount,
  paymentMethodAmount,
  paymentMethodLast4,
  currency,
  // tipAmount,
}: PaymentBreakdownSectionProps) {
  const { t } = useTranslation();

  return (
    <InfoSection title={t("payment.breakdown")}>
      <InfoRow
        label={t("payment.mezzaCredits")}
        value={
          <CurrencyAmount
            amount={formatMonetaryAmount(mezzaCreditsAmount)}
            currency={currency}
          />
        }
        isNumeric
      />
      <InfoRow
        label={`${t("payment.method")} (${paymentMethodLast4})`}
        value={
          <CurrencyAmount
            amount={formatMonetaryAmount(paymentMethodAmount)}
            currency={currency}
          />
        }
        // description={{
        //   label: t("payment.includesTip", {
        //     tipAmount: formatAmount(tipAmount),
        //   }),
        // }}
        isNumeric
      />
    </InfoSection>
  );
}
